export const gameAndMultimediaDevelopmentConst = {
  path: "/single-programs/game-and-multimedia-development",
  title: "ФАКУЛЬТЕТ ИСКУССТВА И ЦИФРОВЫХ ТЕХНОЛОГИЙ – РАЗРАБОТКА ИГР И МУЛЬТИМЕДИА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Разработка игр и мультимедиа — когда творчество встречается с технологией</h2>
      <p>
        Эта программа объединяет программирование, визуальное искусство, гейм-дизайн и звук. Студенты осваивают создание компьютерных игр,
        анимации, 3D-графики, интерактивных медиа и виртуальных сред. Акцент — на практических проектах, игровых движках и мультимедийных
        технологиях.
      </p>
      <p>Идеально подходит для будущих разработчиков, дизайнеров и художников цифрового мира.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы гейм-дизайна и сценарного построения</li>
        <li>Программирование (C#, Unity, Unreal Engine)</li>
        <li>3D-моделирование и анимация</li>
        <li>Визуальные эффекты и спецэффекты</li>
        <li>Звук в мультимедиа и играх</li>
        <li>Интерактивные технологии и UX-дизайн</li>
        <li>Работа с движками (Unity, Unreal Engine, Godot)</li>
        <li>Командная разработка и управление проектами</li>
      </ul>
      <p>Программа включает реальные игровые и мультимедийные проекты, хакатоны, воркшопы и коллаборации с индустрией.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Гейм-дизайнер</li>
        <li>Разработчик игр (Game Developer)</li>
        <li>Художник по персонажам или окружению</li>
        <li>3D-аниматор и визуальный художник</li>
        <li>UI/UX-дизайнер для игр и приложений</li>
        <li>Специалист по интерактивным медиа и виртуальной реальности</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€50,000 до €95,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, актуальный в индустрии</li>
        <li>Обучение на русском или английском языке</li>
        <li>Очная и дистанционная форма на выбор</li>
        <li>Программа построена на современных игровых и медиа-технологиях</li>
        <li>Доступ к профессиональному софту и оборудованию</li>
        <li>Поддержка проектов и выход на международные конкурсы</li>
      </ul>
      <p>Ты не просто играешь — ты создаешь реальности</p>
      <p>
        Наши студенты разрабатывают собственные игры, проходят практику в студиях и участвуют в международных фестивалях цифрового
        искусства.
      </p>
      <br />
      <p>«Игры — это новый язык культуры. Мы учим говорить на нём уверенно и профессионально.»</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам определиться с направлением, собрать документы и подать заявку.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Разработка игр и мультимедиа — когда творчество встречается с технологией
    Эта программа объединяет программирование, визуальное искусство, гейм-дизайн и звук. Студенты осваивают создание компьютерных игр, анимации, 3D-графики, интерактивных медиа и виртуальных сред. Акцент — на практических проектах, игровых движках и мультимедийных технологиях.
    Идеально подходит для будущих разработчиков, дизайнеров и художников цифрового мира.
    Что вы будете изучать?
    • Основы гейм-дизайна и сценарного построения
    • Программирование (C#, Unity, Unreal Engine)
    • 3D-моделирование и анимация
    • Визуальные эффекты и спецэффекты
    • Звук в мультимедиа и играх
    • Интерактивные технологии и UX-дизайн
    • Работа с движками (Unity, Unreal Engine, Godot)
    • Командная разработка и управление проектами
    Программа включает реальные игровые и мультимедийные проекты, хакатоны, воркшопы и коллаборации с индустрией.
    Кем можно работать после окончания?
    • Гейм-дизайнер
    • Разработчик игр (Game Developer)
    • Художник по персонажам или окружению
    • 3D-аниматор и визуальный художник
    • UI/UX-дизайнер для игр и приложений
    • Специалист по интерактивным медиа и виртуальной реальности
    Зарплата в Европе: от €50,000 до €95,000 в год
    Почему выбирают нас?
    • Европейский диплом, актуальный в индустрии
    • Обучение на русском или английском языке
    • Очная и дистанционная форма на выбор
    • Программа построена на современных игровых и медиа-технологиях
    • Доступ к профессиональному софту и оборудованию
    • Поддержка проектов и выход на международные конкурсы
    Ты не просто играешь — ты создаешь реальности
    Наши студенты разрабатывают собственные игры, проходят практику в студиях и участвуют в международных фестивалях цифрового искусства.
    «Игры — это новый язык культуры. Мы учим говорить на нём уверенно и профессионально.»

    Как поступить?
    Приёмная комиссия поможет вам определиться с направлением, собрать документы и подать заявку.
  `,
};
